import { Box, Heading, Text, Image,HStack, Flex, SimpleGrid } from '@chakra-ui/react';
import PublicLayout from "./Layouts/PublicLayout"
import TermsConditions from "../../Components/TermsConditions"

const B2CTermsAndConditions = () => (
  <PublicLayout>
      <Box p={4}>
<TermsConditions />
      </Box>
  </PublicLayout>
);

export default B2CTermsAndConditions;